import composeInstallation from '../utils/composeInstallation'

const install = composeInstallation({
  name: 'klarna',
  scriptId: 'klarna-js',
  makeScriptUri: () => 'https://x.klarnacdn.net/kp/lib/v1/api.js'
})

export { install }
